var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BRow',[_vm._l((_vm.glossary),function(prop,index){return [_c('dt',{key:`prop-${index}`,staticClass:"col-lg-4",attrs:{"data-testid":`prop-${index}`}},[_vm._v(" "+_vm._s(prop.name)+" ")]),_c('dd',{key:`prop-value-${index}`,staticClass:"col-lg-8 mb-4",attrs:{"data-testid":`prop-value-${index}`}},[_vm._v(" "+_vm._s(prop.value)+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }